'use client'

import { useEffect, useState } from 'react'
import type { DocsTocEntry } from '@/lib/docs'

export function DocsTableOfContents({ entries }: { entries: DocsTocEntry[] }) {
  const [activeId, setActiveId] = useState<string | null>(null)

  useEffect(() => {
    if (entries.length === 0) return

    const observer = new IntersectionObserver(
      items => {
        for (const item of items) {
          if (item.isIntersecting) {
            setActiveId(item.target.id)
          }
        }
      },
      { rootMargin: '-80px 0px -70% 0px', threshold: 0 },
    )

    for (const entry of entries) {
      const el = document.getElementById(entry.id)
      if (el) observer.observe(el)
    }

    return () => observer.disconnect()
  }, [entries])

  if (entries.length === 0) return null

  return (
    <nav className="flex flex-col gap-0.5 text-[13px]">
      {entries.map(entry => (
        <a
          key={entry.id}
          href={`#${entry.id}`}
          className={`block rounded-md py-1 transition-colors ${entry.level > 0 ? 'ps-4' : 'ps-2'} ${
            activeId === entry.id ? 'text-foreground' : 'text-muted-foreground/60 hover:text-muted-foreground'
          }`}
        >
          {entry.label}
        </a>
      ))}
    </nav>
  )
}
